export default __webpack_public_path__ + "static/media/guia-1-2.fd4017af.svg";